import(/* webpackMode: "eager" */ "/workspace/pkgs/apps/a-tm/src/app/(fullPage)/(postMain)/article/labels/[id]/error.tsx");
